module.exports = __webpack_public_path__ + "img/image-29.68cc7db5.jpg";